export const vorhersage = {
    AktuelleVorhersageClass: {
        url: "VorhersageInfo",
        receiveType: 'RECEIVE_AktuelleVorhersage_vorhersageReducer'
    },
};